import React, { Fragment } from 'react';
import cx from 'classnames';
import { Box, Button, MenuItem, Typography } from '@material-ui/core';

import Loader from 'src/utils/Loader';
import PlusIcon from 'src/assets/icons/Plus';
import { FieldSelect } from 'src/components/FieldSelect';
import { useHandlers } from './useHandlers';
import { useViewState } from './useViewState';
import { useStyles } from './useStyles';

export const CopyScoringModelPanel = ({
  className,
  onCreationPopupClose,
  error,
  generationTool,
}) => {
  const styles = useStyles();

  const { handleChange, handleOpenCreateCopyScoringModelPopup } = useHandlers(
    onCreationPopupClose,
    generationTool
  );
  const { copyScoringModels, selectedModelId, isLoading } = useViewState();
  const isCopyScoringModelsEmpty = !copyScoringModels || copyScoringModels.length === 0;

  return (
    <Box className={cx(styles.root, className)}>
      {isLoading ? (
        <Loader size={20} />
      ) : (
        <Fragment>
          <Typography className={styles.description}>
            {isCopyScoringModelsEmpty ? (
              <Fragment>
                Help Anyword generate and score your copy more accurately
                <br />
                by uploading a custom scoring model from your historic performance data.
              </Fragment>
            ) : (
              'Select one of your custom scoring models for more accurate results.'
            )}
          </Typography>

          {!isCopyScoringModelsEmpty && (
            <FieldSelect
              className={styles.selectMenuRoot}
              value={selectedModelId}
              onChange={handleChange}
              renderValue={(selectedValue) => {
                const copyScoringModel = copyScoringModels.find((n) => n.id === selectedValue);
                return copyScoringModel ? copyScoringModel.title : '';
              }}
              placeholder="Choose your custom scoring model"
              disablePortal
              displayEmpty
              error={error}
            >
              {copyScoringModels.map((item) => (
                <MenuItem
                  className={styles.selectItem}
                  key={item.id}
                  value={item.id}
                >
                  {item.title}
                </MenuItem>
              ))}
            </FieldSelect>
          )}

          <Button
            className={cx(styles.buttonAction, styles.buttonWide)}
            onClick={handleOpenCreateCopyScoringModelPopup}
            startIcon={<PlusIcon className={styles.iconButtonPlus} />}
            color="primary"
            variant="outlined"
          >
            Custom model
          </Button>
        </Fragment>
      )}
    </Box>
  );
};
